import {useState, useEffect} from 'react';
import * as api from './api';
import NoteForm from './components/NoteForm';
import NoteList from './components/NoteList';
import TagFilter from './components/TagFilter';
import './styles.css';

export default function App() {
    const [notes, setNotes] = useState([]);
    const [tags, setTags] = useState([]);
    const [activeTag, setActiveTag] = useState(null);
    const [error, setError] = useState(null);

    const load = async (tag) => {
        try {
            setNotes(await api.getNotes(tag));
            setTags(await api.getTags());
            setError(null);
        } catch (e) {
            setError(e.message);
        }
    };

    // Équivalent du ngOnInit, + relancé à chaque changement de filtre
    useEffect(() => {
        load(activeTag);
    }, [activeTag]);

    const handleCreate = async (note) => {
        await api.createNote(note);
        await load(activeTag);
    };

    const handleUpdate = async (id, note) => {
        await api.updateNote(id, note);
        await load(activeTag);
    };

    const handleDelete = async (id) => {
        await api.deleteNote(id);
        await load(activeTag);
    };

    return (
        <div className="app">
            <h1>Mini Note App</h1>

            <h2>Nouvelle note</h2>
            <NoteForm onSubmit={handleCreate}/>

            <h2>Mes notes</h2>
            <TagFilter tags={tags} activeTag={activeTag} onChange={setActiveTag}/>
            {error && <p className="error">{error}</p>}
            <NoteList notes={notes} onUpdate={handleUpdate} onDelete={handleDelete}/>
        </div>
    );
}
